import React from 'react';
import Select from '../commons/Select.jsx'
import Helper from "../../../model/Helper";
import RadioGroup from '../commons/RadioGroup.jsx'
import SidebarFrame from "./SidebarFrame";
import NumberInput from "../commons/NumberInput";

export default class TrennwandboxSettings extends SidebarFrame {

    renderTitle() {
        return I18N("Trennwandbox");
    }

    getSidebarParent() {
        return "einbauten";
    }

    renderBody() {
        const trennwandbox = this.props.model.vsData;

        const element = trennwandbox.elements[0];

        return (
            <div>
                <NumberInput label={I18N(`Wie breit soll die linke Hälte sein?`)} value={element.size.x} onCommit={APP.model.tryWrap(this,value=>{
                        element.size.x=value;
                        element.locked.x=true;
                })} unit="cm" decimals={0}/>
                <NumberInput label={I18N(`Breite der rechten Seite`)} value={trennwandbox.elements[1].size.x} unit="cm"  decimals={0} disabled={true}/>
            </div>
        )
    }
}